import React from 'react';
import './Ourwork.css';
import businessman from '../Imges/Group 32.png';
import Ourwork2 from '../Componet/Ourwork2';

const OurWorks = () => {
  return (
    <>
      <Ourwork2 />
    </>
  );
};

export default OurWorks;
